export const StripeOverlay = ({ rounded = 'rounded-lg' }) => (
  <span
    className={`pointer-events-none absolute inset-0 ${rounded} opacity-10 transition-opacity duration-250`}
    style={{
      background:
        'repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(28,157,234,0.08) 2px, rgba(28,157,234,0.08) 4px)'
    }}
  />
)
